import { mount } from "svelte";
import App from "./App.svelte";

// Firebase（任意）。firebase-config.js が "YOUR_..." のままなら
// firebase-sync.js 側が自動で無効化し、オフライン専用として動く。
import "../firebase-config.js";
import "../firebase-sync.js";

const target = document.getElementById("app");
target.innerHTML = "";

export default mount(App, { target });
